import isEqual from 'fast-deep-equal';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn } from 'zustand/traditional';

import type { LoadingState, LoadingStateProperties } from './types/loading.state';

const initialState: LoadingStateProperties = {
  isLoading: false,
};

const action = (name: string) => {
  return { type: `loading/${name}` };
};

export const useLoadingStore = createWithEqualityFn<LoadingState>()(
  immer(
    devtools((set, _) => {
      return {
        ...initialState,
        reset: () => {
          set({ ...initialState }, false, action('reset'));
        },
        setIsLoading: (value) => {
          set({ isLoading: value }, false, action('setIsLoading'));
        },
      };
    })
  ),
  isEqual
);
